import actionTypes from 'SRC/modules/redux/actionTypes'

export const setServices = services => ({
  type: actionTypes.SET_SERVICES,
  payload: services
})
